import { c as _c } from "react-compiler-runtime";
import React from "react";
import { Button, Input as AriaInput, Select as AriaSelect, SelectValue as AriaSelectValue } from "react-aria-components";
import { ListBox } from "./ListBox.js";
import { Popover } from "./Popover.js";
import { inputDropdown, inputDropdownContainer, selectText } from "./UnitInput.css.js";
import { ChevronButton } from "./shared/ChevronButton.js";
import { InputBuilder } from "./shared/InputBuilder.js";
import { extractInputBuilderProps } from "./shared/inputBuilderHelper.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SelectValue = t0 => {
  const $ = _c(3);
  const {
    size,
    placeholder
  } = t0;
  let t1;
  if ($[0] !== placeholder || $[1] !== size) {
    t1 = /*#__PURE__*/_jsx(AriaSelectValue, {
      children: t2 => {
        const {
          selectedText,
          isPlaceholder
        } = t2;
        return isPlaceholder ? /*#__PURE__*/_jsx("span", {
          className: selectText({
            size,
            type: "placeholder"
          }),
          children: placeholder
        }) : /*#__PURE__*/_jsx("span", {
          className: selectText({
            size,
            type: "text"
          }),
          children: selectedText
        });
      }
    });
    $[0] = placeholder;
    $[1] = size;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export function UnitDropdown(t0) {
  const $ = _c(23);
  let children;
  let popoverWidth;
  let props;
  let selectedPlaceholder;
  let t1;
  let triggerRef;
  if ($[0] !== t0) {
    ({
      children,
      selectedPlaceholder,
      popoverWidth,
      size: t1,
      triggerRef,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = popoverWidth;
    $[3] = props;
    $[4] = selectedPlaceholder;
    $[5] = t1;
    $[6] = triggerRef;
  } else {
    children = $[1];
    popoverWidth = $[2];
    props = $[3];
    selectedPlaceholder = $[4];
    t1 = $[5];
    triggerRef = $[6];
  }
  const size = t1 === undefined ? "m" : t1;
  const ref = React.useRef(null);
  const width = popoverWidth;
  let t2;
  if ($[7] !== selectedPlaceholder || $[8] !== size) {
    t2 = /*#__PURE__*/_jsx(SelectValue, {
      size: size,
      placeholder: selectedPlaceholder
    });
    $[7] = selectedPlaceholder;
    $[8] = size;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /*#__PURE__*/_jsx(ChevronButton, {
      element: "div"
    });
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2) {
    t4 = /*#__PURE__*/_jsxs(Button, {
      ref: ref,
      className: inputDropdown,
      children: [t2, t3]
    });
    $[11] = t2;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = triggerRef ?? ref;
  let t6;
  if ($[13] !== children) {
    t6 = /*#__PURE__*/_jsx(ListBox, {
      children: children
    });
    $[13] = children;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6 || $[17] !== width) {
    t7 = /*#__PURE__*/_jsx(Popover, {
      placement: "bottom end",
      shouldFlip: true,
      triggerRef: t5,
      width: width,
      children: t6
    });
    $[15] = t5;
    $[16] = t6;
    $[17] = width;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== props || $[20] !== t4 || $[21] !== t7) {
    t8 = /*#__PURE__*/_jsxs(AriaSelect, {
      ...props,
      className: inputDropdownContainer,
      children: [t4, t7]
    });
    $[19] = props;
    $[20] = t4;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}
export function UnitInput(t0) {
  const $ = _c(29);
  let children;
  let props;
  let unitLabel;
  if ($[0] !== t0) {
    ({
      children,
      unitLabel,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = unitLabel;
  } else {
    children = $[1];
    props = $[2];
    unitLabel = $[3];
  }
  let t1;
  if ($[4] !== props) {
    t1 = extractInputBuilderProps(props);
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const {
    inputBuilderProps,
    restProps
  } = t1;
  let defaultSelectedKey;
  let inputProps;
  let onSelectionChange;
  let popoverWidth;
  let selectedKey;
  let selectedPlaceholder;
  if ($[6] !== restProps) {
    ({
      selectedPlaceholder,
      onSelectionChange,
      selectedKey,
      defaultSelectedKey,
      popoverWidth,
      ...inputProps
    } = restProps);
    $[6] = restProps;
    $[7] = defaultSelectedKey;
    $[8] = inputProps;
    $[9] = onSelectionChange;
    $[10] = popoverWidth;
    $[11] = selectedKey;
    $[12] = selectedPlaceholder;
  } else {
    defaultSelectedKey = $[7];
    inputProps = $[8];
    onSelectionChange = $[9];
    popoverWidth = $[10];
    selectedKey = $[11];
    selectedPlaceholder = $[12];
  }
  const ref = React.useRef(null);
  const size = inputBuilderProps.size ?? "m";
  let t2;
  if ($[13] !== children || $[14] !== defaultSelectedKey || $[15] !== onSelectionChange || $[16] !== popoverWidth || $[17] !== selectedKey || $[18] !== selectedPlaceholder || $[19] !== size || $[20] !== unitLabel) {
    t2 = /*#__PURE__*/_jsx(UnitDropdown, {
      "aria-label": unitLabel,
      selectedPlaceholder: selectedPlaceholder,
      onSelectionChange: onSelectionChange,
      selectedKey: selectedKey,
      defaultSelectedKey: defaultSelectedKey,
      popoverWidth: popoverWidth,
      size: size,
      triggerRef: ref,
      children: children
    });
    $[13] = children;
    $[14] = defaultSelectedKey;
    $[15] = onSelectionChange;
    $[16] = popoverWidth;
    $[17] = selectedKey;
    $[18] = selectedPlaceholder;
    $[19] = size;
    $[20] = unitLabel;
    $[21] = t2;
  } else {
    t2 = $[21];
  }
  let t3;
  if ($[22] !== inputProps) {
    t3 = /*#__PURE__*/_jsx(AriaInput, {
      ...inputProps
    });
    $[22] = inputProps;
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  let t4;
  if ($[24] !== inputBuilderProps || $[25] !== size || $[26] !== t2 || $[27] !== t3) {
    t4 = /*#__PURE__*/_jsx(InputBuilder, {
      ...inputBuilderProps,
      ref: ref,
      size: size,
      right: t2,
      children: t3
    });
    $[24] = inputBuilderProps;
    $[25] = size;
    $[26] = t2;
    $[27] = t3;
    $[28] = t4;
  } else {
    t4 = $[28];
  }
  return t4;
}
//# sourceMappingURL=UnitInput.js.map